import React from "react";
import { Link } from "react-router-dom";

export const Header = ({ notice }) => (
  <header className="non-smartphone">
    <div className="texts">
      <div className="black-wrapper uk-text-center">
        <p>
          <a className="logo" href="/">
            <img
              src="/assets/images/logo.png"
              alt="Logo Youcan Fitness Factory"
            />
          </a>
        </p>
        <h1>Il centro fitness di Milano Bovisa</h1>
      </div>

      <div className="black-wrapper">
        <p className="timing">
          Lun-Ven: 07:30 - 23:00
          <br />
          Sabato: 09:30 - 19:00
          <br />
          Domenica: 09:30 - 14:00
        </p>
        <p className="details">
          Tel.: <a href="tel:0280886302">02.80.88.63.02</a>
          <br />
          <Link to="/contatti">info@youcanfitnessfactory.it</Link>
          <br />
          Via Ugoni 15, Milano
        </p>
      </div>
    </div>

    {notice && (
      <div className="mini-news">
        <span className="title">News</span>
        <div dangerouslySetInnerHTML={{ __html: notice.join("<br />") }} />
      </div>
    )}

    <div
      className="backgrounds"
      data-uk-slideshow="min-height: 1000; autoplay: true; autoplay-interval: 3000; pause-on-hover: false"
    >
      <ul className="uk-slideshow-items">
        <li>
          <img
            src="/assets/images/slideshow/youcan-5.jpg"
            alt=""
            data-uk-cover
          />
        </li>
        <li>
          <img
            src="/assets/images/slideshow/youcan-7.jpg"
            alt=""
            data-uk-cover
          />
        </li>
        <li>
          <img
            src="/assets/images/slideshow/youcan-4.jpg"
            alt=""
            data-uk-cover
          />
        </li>
        <li>
          <img
            src="/assets/images/slideshow/youcan-8.jpg"
            alt=""
            data-uk-cover
          />
        </li>
        <li>
          <img
            src="/assets/images/slideshow/youcan-3.jpg"
            alt=""
            data-uk-cover
          />
        </li>
        <li>
          <img
            src="/assets/images/slideshow/youcan-6.jpg"
            alt=""
            data-uk-cover
          />
        </li>
        <li>
          <img
            src="/assets/images/slideshow/youcan-1.jpg"
            alt=""
            data-uk-cover
          />
        </li>
      </ul>
    </div>
  </header>
);



// WEBPACK FOOTER //
// ./src/ui/components/Header.js